import { action, observable } from 'mobx';
import apiCaller from '../../utils/api-caller';

class CmsLanguageStore {
  @observable data = [];
  @observable activeLanguages = [];
  @observable activeLanguageOptions = [];
  @observable activeShortLanguageOptions = [];
  @observable selectedData = null;
  @observable defaultLanguageId = 1;

  @action getData() {
    this.selectedData = null;
    return apiCaller.CmsLanguages.get().then(resp => {
      if (!resp.isError) {
        if (resp.data) {
          this.data = resp.data;
        }
      }
    })
  }

  @action getActives() {
    return apiCaller.CmsLanguages.getActives().then(resp => {
      if (!resp.isError) {
        if (resp.data) {
          this.activeLanguages = resp.data;
          let languageOptions = [];
          this.activeLanguages.map(language => {
            languageOptions.push({
              label: language.originalName,
              value: language.code
            });
            return language;
          });

          this.activeLanguageOptions = languageOptions;

          let shortLanguageOptions = [];
          this.activeLanguages.map(language => {
            shortLanguageOptions.push({
              label: language.originalName,
              value: language.code
            });
            return language;
          });

          this.activeShortLanguageOptions = shortLanguageOptions;
        }
      }
    })
  }

  @action update() {
    return apiCaller.CmsLanguages.update(this.selectedData.id, this.selectedData.isAvailable, this.selectedData.sort);
  }

  @action activate(id) {
    return apiCaller.CmsLanguages.activate(id);
  }

  @action deactivate(id) {
    return apiCaller.CmsLanguages.deactivate(id);
  }

  @action edit(id) {
    this.selectedData = this.data.find(fi => fi.id === id);
  }

  @action cancelUpdate() {
    this.getData();
  }

  @action setSort(value) {
    this.selectedData.sort = value;
  }

  @action setIsAvailable(value) {
    this.selectedData.isAvailable = value;
  }
}

export default new CmsLanguageStore();